var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShareInline = function SvgIconShareInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-share",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8.727,
    viewBox: "0 0 12 8.727"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    strokeWidth: 5,
    fill: "currentColor",
    d: "M222.455 438.206v-1.334a.805.805 0 0 1 .3-.617 1.146 1.146 0 0 1 1.443 0l4.8 4.108-4.8 4.108a1.146 1.146 0 0 1-1.443 0 .805.805 0 0 1-.3-.617v-1.292a8.685 8.685 0 0 0-5.455 2.029c0-3.733 2.284-6.137 5.455-6.385Z",
    transform: "translate(-217 -436)"
  }))));
};
export { SvgIconShareInline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zaGFyZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTIiIGhlaWdodD0iOC43MjciIHZpZXdCb3g9IjAgMCAxMiA4LjcyNyI+CiAgICA8ZyBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8cGF0aCBpZD0iUGF0aF8yNDEiCiAgICAgICAgICAgICAgZGF0YS1uYW1lPSJQYXRoIDI0MSIKICAgICAgICAgICAgICBzdHJva2Utd2lkdGg9IjUiCiAgICAgICAgICAgICAgZmlsbD0iY3VycmVudENvbG9yIgogICAgICAgICAgICAgIGQ9Ik0yMjIuNDU1LDQzOC4yMDZ2LTEuMzM0YS44MDUuODA1LDAsMCwxLC4zLS42MTcsMS4xNDYsMS4xNDYsMCwwLDEsMS40NDMsMGw0LjgsNC4xMDgtNC44LDQuMTA4YTEuMTQ2LDEuMTQ2LDAsMCwxLTEuNDQzLDAsLjgwNS44MDUsMCwwLDEtLjMtLjYxN3YtMS4yOTJBOC42ODUsOC42ODUsMCwwLDAsMjE3LDQ0NC41OTFDMjE3LDQ0MC44NTgsMjE5LjI4NCw0MzguNDU0LDIyMi40NTUsNDM4LjIwNloiCiAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxNyAtNDM2KSIKICAgICAgICAvPgogICAgPC9nPgo8L3N2Zz4K";